import { useCallback, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { InputNumber } from "@/components/ui/input/input-number";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

import type { ChangeEventHandler } from "react";

type Props = {
	value: number | undefined;
	handleInput: (e: number | undefined) => void;
	errorMessage?: string;
	textAlign?: "left" | "center" | "right";
	hiddenSpinButton?: boolean;
	needsDecimal?: boolean;
	disabled?: boolean;

	label?: string;
};

/**
 * 数値入力フィールドコンポーネント
 */
export const InputNumberField = ({
	value,
	handleInput,
	errorMessage,
	hiddenSpinButton = true,
	textAlign = "center",
	needsDecimal = false,
	disabled = false,
	label,
}: Props) => {
	const textAlignStyle = textAlign === "center" ? "text-center" : textAlign === "right" ? "text-right" : "text-left";
	const hiddenSpinButtonStyle = hiddenSpinButton ? "hidden-spin-button" : "";

	/**
	 * _value = 0 の時に、数値を入力されると'01'のように0埋めされるのを防ぐため、
	 * _value を文字列に変換する
	 */
	const valueAsString = useMemo(() => (value !== undefined ? String(value) : ""), [value]);

	const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
		(e) => {
			const valueAsNumber = e.target.valueAsNumber;
			const value = isNaN(valueAsNumber) ? undefined : valueAsNumber;
			handleInput(value);
		},
		[handleInput],
	);

	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>

			<InputNumber
				className={cn(textAlignStyle, hiddenSpinButtonStyle)}
				value={valueAsString ?? undefined}
				needsDecimal={needsDecimal}
				disabled={disabled}
				onChange={handleChange}
			/>
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
